import { useId } from 'vue'

/**
 * Returns a stable, SSR-safe unique ID string.
 * Wraps Vue 3.5 built-in useId() with an optional prefix.
 *
 * @param prefix - Optional prefix prepended to the generated ID.
 */
export function useUniqueId(prefix?: string): string {
  const id = useId()
  return prefix ? `${prefix}-${id}` : id
}
